var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLenovo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 187,
    height: 63,
    viewBox: "0 0 187 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_229_1210)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187 0H0V62.3329H187V0Z",
    fill: "#E1251B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4671 21.0083C78.7054 21.0083 75.5638 22.2881 73.6447 24.8523V24.8476V24.85V21.4115H67.0576V45.4025H73.6447V31.7515C73.6447 29.2947 75.5486 26.6826 79.0759 26.6826C81.8026 26.6826 84.6228 28.5783 84.6228 31.7515V45.4025H91.211V30.5301C91.211 25.0136 87.2641 21.0095 81.4683 21.0095",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.031 21.4111L132.075 37.7538L126.119 21.4111H118.595L128.466 45.3927H135.684L145.555 21.4111H138.031Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0464 38.025C57.273 40.0762 55.6893 40.567 53.1613 40.567C50.8857 40.567 49.1046 39.8611 47.8481 38.6211L64.6898 31.6343C64.3228 29.0303 63.3353 26.7057 61.8135 24.9373C59.6011 22.3661 56.3251 21.0068 52.3385 21.0068C45.0946 21.0068 39.6318 26.3515 39.6318 33.4084C39.6318 40.4654 45.1063 45.8089 53.0631 45.8089C57.5207 45.8089 62.08 43.6958 64.2107 41.2274L60.0452 38.025H60.0464ZM47.39 28.6388C48.512 27.1323 50.299 26.2487 52.4577 26.2487C54.8326 26.2487 56.6325 27.6044 57.564 29.6053L46.0553 34.3797C45.7409 31.93 46.3673 30.0132 47.3912 28.6388H47.39Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0044 39.3516H24.0316V14.2363H17.3545V45.401H39.0044V39.3516Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.384 45.8054C150.18 45.8054 144.535 40.4385 144.535 33.4073C144.535 26.3761 150.219 21.0068 157.473 21.0068C164.728 21.0068 170.321 26.3737 170.321 33.4073C170.321 40.4408 164.639 45.8054 157.384 45.8054ZM157.384 26.6519C153.705 26.6519 151.035 29.4394 151.035 33.4061C151.035 37.3728 153.863 40.1603 157.473 40.1603C161.083 40.1603 163.823 37.2957 163.823 33.4061C163.823 29.5165 160.995 26.6519 157.384 26.6519Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.665 45.8054C99.4605 45.8054 93.8154 40.4385 93.8154 33.4073C93.8154 26.3761 99.4991 21.0068 106.753 21.0068C114.008 21.0068 119.602 26.3737 119.602 33.4073C119.602 40.4408 113.919 45.8054 106.665 45.8054ZM106.665 26.6519C102.985 26.6519 100.315 29.4394 100.315 33.4061C100.315 37.3728 103.143 40.1603 106.753 40.1603C110.364 40.1603 113.103 37.2957 113.103 33.4061C113.103 29.5165 110.275 26.6519 106.665 26.6519Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.221 42.5529H170.155V41.9475H172.947V42.5529H171.882V45.4011H171.22V42.5529H171.221ZM173.688 41.9463H174.396L175.439 43.5837L176.482 41.9463H177.167V45.3999H176.527V42.9444L175.461 44.604H175.394L174.329 42.9444V45.3999H173.69V41.9463H173.688Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_229_1210"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 187,
    height: 62.3329,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLenovo);
export default __webpack_public_path__ + "static/media/Lenovo.8953865e7c36daa38dbe47157283d1a5.svg";
export { ForwardRef as ReactComponent };